export { default } from './ModalHeading';
export * from './ModalHeading.types';
